import { SelectionChangedEvent } from "ag-grid-community";
import { RefundEntity } from "domain/entity/Refund/RefundEntity";
import { INITIAL_REFUND_COL_DEF, INITIAL_REFUND_COL_DEF_FOR_OTHER, transferRowData } from "presentation/constant/Refund/RefundColumnDefinition";
import { useRefundVM } from "presentation/hook/Refund/useRefundVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useRefundTracked } from "presentation/store/Refund/RefundProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

const RefundTablePanel: React.FC = () => {
    const [refundState] = useRefundTracked();
    const refundVM = useRefundVM();
    const { refundList } = refundState;
    const gridRef: any = useRef(null);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(refundState.isSearchLoading || (!refundState.isSearchLoading &&
            refundList && refundList.length) ? false : true);

        if (gridRef.current?.gridRef.current && !refundState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [refundState.isSearchLoading, refundList]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        refundVM.updateSelectedRows(selectedRows);
    }, [refundVM])

    const handleRowDoubleClick = useCallback((entity: RefundEntity) => {
        refundVM.onRowDoubleClick(entity);
    }, [refundVM])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='refund-table'
                isNewColumnSetting={true}
                columns={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_REFUND_COL_DEF : INITIAL_REFUND_COL_DEF_FOR_OTHER}
                data={transferRowData(refundList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                rowSelection={"multiple"}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                onRowDoubleClick={(e: any, entity: RefundEntity) => handleRowDoubleClick(entity)}
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [handleRowDoubleClick, handleSelectionChange, refundList, operatingUnit, showOverlay])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(RefundTablePanel);
